var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZoomWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_264",
    "data-name": "Rectangle 264",
    width: 20,
    height: 20,
    transform: "translate(1804 40)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_68",
    "data-name": "Mask Group 68",
    transform: "translate(-1804 -40)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrows-fullscreen",
    transform: "translate(1803.969 39.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_845",
    "data-name": "Group 845"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M7.308,12.755a.627.627,0,0,0-.887,0L1.285,17.891V14.42a.627.627,0,1,0-1.254,0V19.4a.627.627,0,0,0,.627.627H5.643a.627.627,0,1,0,0-1.254H2.172l5.136-5.136A.627.627,0,0,0,7.308,12.755Zm5.447,0a.627.627,0,0,1,.887,0l5.136,5.136V14.42a.627.627,0,1,1,1.254,0V19.4a.627.627,0,0,1-.627.627H14.42a.627.627,0,1,1,0-1.254h3.471l-5.136-5.136a.627.627,0,0,1,0-.887Zm0-5.447a.627.627,0,0,0,.887,0l5.136-5.136V5.643a.627.627,0,1,0,1.254,0V.658A.627.627,0,0,0,19.4.031H14.42a.627.627,0,1,0,0,1.254h3.471L12.755,6.421a.627.627,0,0,0,0,.887Zm-5.447,0a.627.627,0,0,1-.887,0L1.285,2.172V5.643a.627.627,0,1,1-1.254,0V.658A.627.627,0,0,1,.658.031H5.643a.627.627,0,1,1,0,1.254H2.172L7.308,6.421A.627.627,0,0,1,7.308,7.308Z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomWhite);
export default __webpack_public_path__ + "static/media/zoom-white.2fe38134a37db1e8a8bb826edfee1ba1.svg";
export { ForwardRef as ReactComponent };